/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Avatar,
  Button,
  Dropdown,
  Image,
  Popover,
  TableColumnsType,
  Tag,
  Tooltip,
} from "antd";

import { useEffect, useRef, useState } from "react";
import { PopUp } from "../../atoms/PopUp";
import EmptyCard from "../../atoms/EmptyCard";
import { CrossIcon, NeedHelp, TickIcon } from "../../atoms/CustomIcons";
import ConfirmDelete from "../../atoms/ConfirmDelete";
import { useNavigate } from "react-router-dom";
import { CloseCircleOutlined, MoreOutlined } from "@ant-design/icons";
import DashboardTemplate from "../../templates/Dashboard";
import Header from "../../atoms/Header";
import {
  formatEstimatedHrs,
  getCompanyInitials,
  getValueBeforeUnderscore,
  PAGE_LIMIT,
  WORK_ORDER_STATUS,
} from "../../config/utils";
import Filters from "./Components/Filters";
import CancelIcon from "../../atoms/CustomIcons/CancelIcon";
import { useAppDispatch, useAppSelector } from "../../config/hooks";
import {
  getWorkOrdersListing,
  removeWorkOrdersListData,
} from "./ducks/actions";
import { changeWorkOrderStatus } from "./ducks/services";
import { SuccessMessage } from "../../atoms/Toasts/SuccessMessage";
import { ErrorMessage } from "../../atoms/Toasts/ErrorMessage";
import { AxiosError } from "axios";
import TableUi from "../../atoms/Table";

export default function WorkOrders() {
  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const navigate = useNavigate();
  const companyId = pathSegments[pathSegments.length - 1];
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(PAGE_LIMIT);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [archivePopUp, setArchivePopUp] = useState(false);
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [archived, isArchived] = useState(false);
  const [tableRecord, setTableRecord] = useState<any>(null);
  const [filters, setFilters] = useState<{
    type: undefined | string;
    status: undefined | string;
    state: undefined;
    city: undefined;
    last_user_activity: string[] | undefined;
    onboarding_complete_date: string[] | undefined;
    search_text: undefined | string;
  }>({
    type: undefined,
    status: undefined,
    state: undefined,
    city: undefined,
    last_user_activity: undefined,
    onboarding_complete_date: undefined,
    search_text: undefined,
  });

  const workOrdersListData = useAppSelector(
    (state) => state?.workOrders?.workOrdersListData
  );

  const nonRecurringWO = [
    {
      label: "Open",
      value: "OPEN",
      color: "#B2BDC2",
    },
    {
      label: "Scheduled",
      value: "SCHEDULED",
      color: "#D2BE4F",
    },
    {
      label: "Confirmation Pending",
      value: "CONFIRMATION_PENDING",
      color: "#6454F4",
    },
    {
      label: "Approval Pending",
      value: "APPROVAL_PENDING",
      color: "#F06400",
    },
    {
      label: "Completed",
      value: "COMPLETED",
      color: "#00A07D",
    },
    {
      label: "Canceled",
      value: "CANCELED",
      color: "#CD1951",
    },
    {
      label: "Closed",
      value: "CLOSED",
      color: "#f8115aff",
    },
  ];

  const recurringWO = [
    {
      label: "Open",
      value: "OPEN",
      color: "#B2BDC2",
    },
    {
      label: "In Progress",
      value: "IN_PROGRESS",
      color: "#6454F4",
    },
    {
      label: "Completed",
      value: "COMPLETED",
      color: "#00A07D",
    },
    {
      label: "Canceled",
      value: "CANCELED",
      color: "#CD1951",
    },
    {
      label: "Closed",
      value: "CLOSED",
      color: "#f8115aff",
    },
  ];

  const handleStatusChange = (status: string) => {
    setLoading(true);

    const payload = {
      status: status,
    };

    if (tableRecord) {
      changeWorkOrderStatus(payload, tableRecord?.id)
        .then(() => {
          setLoading(false);
          const payload = {
            status: filters?.status ?? undefined,
            offset: pagination > 1 ? limit * (pagination - 1) : pagination - 1,
            limit: limit,
            company_id: companyId,
            // type: filters?.type ?? undefined,
            search_text: filters?.search_text ?? undefined,
          };
          dispatch(getWorkOrdersListing(payload));
          setTableRecord(null);
          SuccessMessage("Status changed");
        })
        .catch((e: unknown) => {
          if (e instanceof AxiosError) {
            setLoading(false);
            ErrorMessage(
              e?.response?.data?.error?.message ?? "Something went wrong"
            );
          } else {
            setLoading(false);
            ErrorMessage("Something went wrong");
          }
        });
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <Popover
          arrow={false}
          overlayClassName="status_popover"
          content={
            <ul>
              {tableRecord?.is_recurring
                ? recurringWO.map((status: any) => (
                    <li key={status.value}>
                      <Button
                        type="text"
                        className="color_popover"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (dropdownRef.current) {
                            dropdownRef?.current?.click(); // Simulate a click to close
                          }
                          handleStatusChange(status.value);
                        }}
                      >
                        <span
                          className="badge"
                          style={{
                            border: `1px solid ${status.color}`,
                            background: status.color,
                          }}
                        />{" "}
                        {status.label}
                        {tableRecord?.status === status?.value && (
                          <TickIcon
                            style={{ color: "#00A07D", marginLeft: "auto" }}
                          />
                        )}
                      </Button>
                    </li>
                  ))
                : nonRecurringWO?.map((status: any) => (
                    <li key={status.value}>
                      <Button
                        type="text"
                        className="color_popover"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (dropdownRef.current) {
                            dropdownRef?.current?.click(); // Simulate a click to close
                          }
                          handleStatusChange(status.value);
                        }}
                      >
                        <span
                          className="badge"
                          style={{
                            border: `1px solid ${status.color}`,
                            background: status.color,
                          }}
                        />{" "}
                        {status.label}
                        {tableRecord?.status === status?.value && (
                          <TickIcon
                            style={{ color: "#00A07D", marginLeft: "auto" }}
                          />
                        )}
                      </Button>
                    </li>
                  ))}
            </ul>
          }
          placement="leftTop"
          getPopupContainer={(trigger) =>
            trigger.parentElement || document.body
          }
        >
          <Button
            type="text"
            icon={
              <img src="/images/potential-deals/change-status.svg" alt="icon" />
            }
            onClick={(e) => {
              e.stopPropagation();
              if (dropdownRef.current) {
                dropdownRef?.current?.click();
              }
            }}
            className="no-hover"
          >
            Change status to ...
          </Button>
        </Popover>
      ),
    },
    {
      key: "2",
      disabled: true,
      label: (
        <Button
          type="text"
          icon={<CancelIcon />}
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
          disabled
          className="no-hover"
        >
          Cancel work order
        </Button>
      ),
    },
  ];

  const statusClassMap: Record<string, string> = {
    IN_PROGRESS: "approval_pending_tag",
    OPEN: "grey_tag",
    COMPLETED: "accepted_tag",
    SCHEDULED: "sent_tag",
    CLOSED: "cancelled_wo_tag",
    CANCELED: "cancelled_wo_tag",
    APPROVAL_PENDING: "approval_pending_tag",
    CONFIRMATION_PENDING: "in_progress_tag",
  };

  const columns: TableColumnsType = [
    {
      title: "Work order",
      dataIndex: "name",
      width: 220,
      render: (text) => (
        <Tooltip title={text ? text : "-"}>
          <span className="table-col-ellipsis" style={{ width: "210px" }}>
            {text ? text : "-"}
          </span>
        </Tooltip>
      ),
      fixed: "left",
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 170,
      render: (text) => {
        const cls = statusClassMap[text] || "default_tag";
        return (
          <Tag
            className={cls}
            style={{ textTransform: "capitalize", border: 0 }}
          >
            {WORK_ORDER_STATUS[text as keyof typeof WORK_ORDER_STATUS]}
          </Tag>
        );
      },
      sorter: (a, b) => a?.status?.localeCompare(b?.status),
    },
    {
      title: "Visits",
      dataIndex: "total_no_of_visits",
      width: 140,
      render: (text) => (
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {text > 1 && (
            <img src="/images/work-orders/reverse_horizontal.svg" alt="icon" />
          )}
          {text ? text : "-"}
        </span>
      ),
      sorter: (a, b) => a?.total_no_of_visits - b?.total_no_of_visits,
    },
    {
      title: "Property",
      dataIndex: "property_name",
      width: 270,
      render: (text) => (
        <Tooltip title={text ? text : "-"}>
          <span className="table-col-ellipsis" style={{ width: "260px" }}>
            {text ? text : "-"}
          </span>
        </Tooltip>
      ),
      sorter: (a, b) => a?.property_name?.localeCompare(b?.property_name),
    },
    {
      title: "Contract",
      dataIndex: "contract_name",
      width: 270,
      render: (text) => (
        <Tooltip title={text ? text : "-"}>
          <span className="table-col-ellipsis" style={{ width: "260px" }}>
            {text ? text : "-"}
          </span>
        </Tooltip>
      ),
      sorter: (a, b) => a?.contract_name?.localeCompare(b?.contract_name),
    },
    {
      title: "Service line",
      dataIndex: "service_line_name",
      width: 270,
      render: (text, record) => {
        return text ? (
          <Tag
            className={`defaultTag ${
              record?.service_line_color
                ? getValueBeforeUnderscore(record?.service_line_color)
                : "default_tag"
            }`}
          >
            {text}
          </Tag>
        ) : (
          "-"
        );
      },
      sorter: (a, b) => a?.service_line?.localeCompare(b?.service_line),
    },
    {
      title: "Performed by",
      dataIndex: "performed_by_crew",
      width: 140,
      render: (text) => (text ? "Crew" : "Crew"),
      sorter: (a, b) =>
        a?.performed_by_crew?.localeCompare(b?.performed_by_crew),
    },
    {
      title: "Crew/Subcontractor",
      dataIndex: "crew_or_contractor_name",
      width: 180,
      render: (text) => (text ? <Tag>{text}</Tag> : "-"),
      sorter: (a, b) =>
        a?.crew_or_contractor_name?.localeCompare(b?.crew_or_contractor_name),
    },
    {
      title: "Production manager",
      dataIndex: "production_manager_name",
      width: 180,
      render: (text, record) =>
        text ? (
          <div className="text_with_avatar">
            {record?.production_manager_image_url ? (
              <div className="participant_avatar">
                <Avatar src={record?.production_manager_image_url} />
              </div>
            ) : (
              <div className="participant_avatar">
                <Avatar>{getCompanyInitials(text)}</Avatar>
              </div>
            )}
            <span style={{ textTransform: "capitalize" }}>{text}</span>
          </div>
        ) : (
          "-"
        ),
      sorter: (a, b) =>
        a?.production_manager?.localeCompare(b?.production_manager),
    },

    {
      title: "Estimated hrs",
      dataIndex: "estimated_hrs",
      width: 150,
      render: (text) => (text ? formatEstimatedHrs(text) : 0),
      align: "right",
      sorter: (a, b) => a?.estimated_hrs - b?.estimated_hrs,
      className: "right-aligned-sorter",
    },
    {
      title: "Scheduled hrs",
      dataIndex: "scheduled_hrs",
      width: 150,
      render: (text) => (text ? text : "-"),
      align: "right",
      sorter: (a, b) => a?.scheduled_hrs - b?.scheduled_hrs,
      className: "right-aligned-sorter",
    },
    {
      title: "Actual hrs",
      dataIndex: "actual_hrs",
      width: 150,
      render: (text) => (text ? text : "-"),
      align: "right",
      sorter: (a, b) => a?.actual_hrs - b?.actual_hrs,
      className: "right-aligned-sorter",
    },
    {
      title: "Scheduled dates",
      dataIndex: "scheduled_dates",
      width: 300,
      render: (text) => text ?? "-",
      sorter: (a, b) => a?.scheduled_dates - b?.scheduled_dates,
      align: "right",
      className: "right-aligned-sorter",
    },
    // {
    //   title: "Progress",
    //   dataIndex: "progress_perc",
    //   width: 100,
    //   render: (text) => text ?? "-",
    //   align: "right",
    //   sorter: (a, b) => a?.progress_perc - b?.progress_perc,
    //   className: "right-aligned-sorter",
    // },
    // {
    //   title: "Efficiency",
    //   dataIndex: "efficiency_perc",
    //   width: 110,
    //   render: (text) => (text ? <Tag className="grey_tag">{text}</Tag> : "-"),
    //   align: "right",
    //   sorter: (a, b) => a?.efficiency_perc - b?.efficiency_perc,
    //   className: "right-aligned-sorter",
    // },
    // {
    //   title: "Estimated labor cost",
    //   dataIndex: "estimated_labor_cost",
    //   width: 180,
    //   render: (text) => text ?? "-",
    //   align: "right",
    //   sorter: (a, b) => a?.estimated_labor_cost - b?.estimated_labor_cost,
    //   className: "right-aligned-sorter",
    // },
    // {
    //   title: "Actual labor cost",
    //   dataIndex: "actual_labor_cost",
    //   width: 180,
    //   render: (text) => text ?? "-",
    //   align: "right",
    //   sorter: (a, b) => a?.actual_labor_cost - b?.actual_labor_cost,
    //   className: "right-aligned-sorter",
    // },
    // {
    //   title: "Estimated material cost",
    //   dataIndex: "estimated_material_cost",
    //   width: 220,
    //   render: (text) => text ?? "-",
    //   align: "right",
    //   sorter: (a, b) => a?.estimated_material_cost - b?.estimated_material_cost,
    //   className: "right-aligned-sorter",
    // },
    // {
    //   title: "Actual material cost",
    //   dataIndex: "actual_material_cost",
    //   width: 195,
    //   render: (text) => text ?? "-",
    //   align: "right",
    //   sorter: (a, b) => a?.actual_material_cost - b?.actual_material_cost,
    //   className: "right-aligned-sorter",
    // },
    // {
    //   title: "Projected revenue",
    //   dataIndex: "projected_revenue",
    //   width: 180,
    //   render: (text) => text ?? "-",
    //   align: "right",
    //   sorter: (a, b) => a?.projected_revenue - b?.projected_revenue,
    //   className: "right-aligned-sorter",
    // },
    // {
    //   title: "Earned revenue",
    //   dataIndex: "earned_revenue",
    //   width: 180,
    //   render: (text) => text ?? "-",
    //   align: "right",
    //   sorter: (a, b) => a?.earned_revenue - b?.earned_revenue,
    //   className: "right-aligned-sorter",
    // },
    {
      title: "Date completed",
      dataIndex: "date_completed",
      width: 170,
      render: (text) => text ?? "-",
      align: "right",
    },

    {
      title: <Image src="/images/table/menu-burger.svg" preview={false} />,
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: (_text, record) => (
        <Dropdown
          menu={{ items }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              console.log("text", record);
              setTableRecord(record);
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
            ref={dropdownRef}
          />
        </Dropdown>
      ),
    },
  ];

  const deleteFunction = () => {
    setLoading(true);
  };

  const deleteClientPopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          selectedRowKeys?.length > 0 ? (
            <>
              Are you sure you want to delete work orders?
              <br />
              This action cannot be undone.
            </>
          ) : (
            <>
              Are you sure you want to delete <b>tableRecord?.name</b>?<br />
              <br />
              This action cannot be undone.
            </>
          )
        }
        btnText={
          selectedRowKeys?.length > 0
            ? `Delete ${
                selectedRowKeys?.length === 1
                  ? selectedRowKeys?.length + " work order"
                  : selectedRowKeys?.length + " work orders"
              }`
            : "Delete order"
        }
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  const archiveFunction = () => {
    setLoading(true);
  };

  const confirmArchivedPopUp = {
    visibility: archivePopUp,
    content: (
      <ConfirmDelete
        title=""
        isArchivePopup={true}
        onClose={() => setArchivePopUp(false)}
        heading='{tableRecord?.status === "active" ? "Archive" : "Activate"}'
        paragraph={
          <>
            Are you sure you want to{" "}
            {/* {tableRecord?.status === "active" ? "archive" : "activate"}{" "}
            <b>{tableRecord?.name}</b>? <br /> <br />
            {tableRecord?.status === "active" && (
              <>This crew won’t be available for use.</>
            )} */}
          </>
        }
        btnText={`${
          "Activate"
          // tableRecord?.status === "active" ? "Archive" : "Activate"
        } crew`}
        btnApi={archiveFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setArchivePopUp(false),
  };

  const onClickRow = (record: any) => {
    return {
      onClick: () => {
        navigate(`/work-orders-profile/${record?.id}/${companyId}`);
      },
    };
  };

  useEffect(() => {
    dispatch(removeWorkOrdersListData());
  }, [dispatch]);

  useEffect(() => {
    if (companyId) {
      const payload = {
        status: filters?.status ?? undefined,
        offset: pagination > 1 ? limit * (pagination - 1) : pagination - 1,
        limit: limit,
        company_id: companyId,
        // type: filters?.type ?? undefined,
        search_text: filters?.search_text ?? undefined,
      };
      dispatch(getWorkOrdersListing(payload));
    }
  }, [dispatch, filters, pagination, limit, companyId]);
  console.log("workOrdersListData", workOrdersListData);
  return (
    <DashboardTemplate loading={loading}>
      <Header
        title="Work orders & tasks"
        // description="View and manage your crews and subcontractors."
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
      />
      <TableUi
        columns={columns}
        data={{
          count: workOrdersListData?.count || 0,
          data: workOrdersListData?.data || [],
        }}
        filters={
          <Filters
            setFilters={setFilters}
            filters={filters}
            archived={archived}
            isArchived={isArchived}
            companyId={companyId}
          />
        }
        pageSize={limit}
        setPageSize={setLimit}
        setCurrentPage={setPagination}
        currentPage={pagination}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        onClickRow={onClickRow}
      />
      {workOrdersListData?.count === 0 && (
        <div className="empty_wrap">
          <EmptyCard
            imageHeight={220}
            title={
              archived
                ? "There are no archived work orders"
                : filters?.search_text
                ? "No results match the filter or search criteria"
                : `There are no ${filters?.status ?? "active"} work orders`
            }
            description={
              archived
                ? "We believe in our absolute success and hope to never have an archived work orders here."
                : filters?.search_text
                ? "Try adjusting the filters and search."
                : ""
            }
            image={
              archived
                ? "/images/empty-icons/no-archived.svg"
                : "/images/empty-icons/no-active.svg"
            }
          />
        </div>
      )}

      {selectedRowKeys?.length !== 0 ? (
        <div className="selection_bar">
          <div className="selected_count">
            <Button
              icon={<CrossIcon style={{ color: "white" }} />}
              className="only_icon"
              type="text"
              onClick={() => setSelectedRowKeys([])}
            />
            {selectedRowKeys.length}{" "}
            {`${selectedRowKeys.length === 1 ? "work order" : "work orders"}`}{" "}
            selected
          </div>
          <div className="selection_buttons">
            <Button
              type="text"
              icon={<CloseCircleOutlined />}
              onClick={() => {
                setIsDeleteModalOpen(true);
              }}
              disabled
              className="disabled_cancel"
            >
              Cancel
              {/* {`${selectedRowKeys.length === 1 ? "work order" : "work orders"}`} */}
            </Button>
          </div>
        </div>
      ) : null}

      <PopUp {...deleteClientPopUp} />
      <PopUp {...confirmArchivedPopUp} />
    </DashboardTemplate>
  );
}
